export const TOTAL_COUNT = 'total_count';
export const UNIQUE_COUNT = 'unique_count';
export const COST = 'cost';
export const COST_IN_LOCAL_CURRENCY = 'cost_in_app_local_currency';
export const REVENUE = 'revenue';
export const ROAS = 'ROAS';
export const REVENUE_IN_LOCAL_CURRENCY = 'revenue_in_local_currency';
